export function computeProfitMargin(unitCost, retailPrice) {
  const cost = Number(unitCost) || 0;
  const retail = Number(retailPrice) || 0;
  const dollar = retail - cost;
  const percent = retail > 0 ? (dollar / retail) * 100 : 0;
  return { dollar, percent };
}